// Intentionally not synced with the SCSS breakpoints, which are not yet consolidated.
export const BREAKPOINTS = {
  MOBILE: 490,
  TABLET: 800,
  DESKTOP: 1000,
} as const;
